import { View, StyleSheet, Text, TouchableOpacity, Image } from "react-native";
import React, { useState, useEffect } from "react";

import GlobalStyles from "../../../globalStyles/globalStyles";
import { BlurView } from "expo-blur";
import { LinearGradient } from "expo-linear-gradient";
import { authToken } from "../../../utils/config";
import FeedIcons from "../../../assets/Icons/FeedIcons";

interface ExperienceData {
  media: {
    images: { url: string }[];
  };
  title: string;
  _id: string;

  // Add other properties as needed
}

export default function ExperienceCard({
  image,
  label,
  value,
  handleLikePress,
  interest,
  id,
  chatProfile,
  imageHeight,
  fromHomeFeed,
}: {
  image: any;
  label: string;
  value: string;
  handleLikePress?: any;
  interest?: boolean;
  id: any;
  chatProfile?: boolean;
  imageHeight?: any;
  fromHomeFeed?: boolean;
}) {
  const [experienceData, setExperienceData] = useState<ExperienceData | null>(
    null
  );
  useEffect(() => {
    const getExperienceById = async (id: any) => {
      try {
        const apiurl = `https://api-dev.spark.hushl.in/experience/${id}`;
        const response = await fetch(apiurl, {
          headers: {
            Authorization: authToken(),
            // Add any other headers if needed
          },
        });

        if (!response.ok) {
          throw new Error(`Error fetching experience by ID ${id}`);
        }

        const experience = await response.json();
        setExperienceData(experience.experience);
      } catch (error) {
        console.error("Error fetching experience:", error as Error);
      }
    };
    getExperienceById(id);
  }, []);

  return (
    <View style={styles.ExperienceCard}>
      <View
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      >
        <Image
          source={{
            uri: experienceData?.media.images[0].url,
          }}
          style={styles.ExperienceCardImg}
        />
        <LinearGradient
          colors={["transparent", "rgba(0,0,0,0.5)"]}
          style={{
            width: "100%",
            height: 200,
            position: "absolute",
            zIndex: 1,
            bottom: 0,
          }}
        />
      </View>
      <View style={styles.HomeDisplayCardInfo}>
        <View>
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <BlurView intensity={100} style={styles.transparentPill}>
              <Text
                style={[
                  GlobalStyles.bodyText,
                  {
                    color: "white",
                    opacity: 0.6,
                    marginHorizontal: 8,
                  },
                ]}
              >
                {label}
              </Text>
            </BlurView>
            <Text
              style={[
                GlobalStyles.title2,
                {
                  color: "white",
                  fontFamily: "InterBold",
                  marginTop: 8,
                },
              ]}
            >
              {experienceData?.title.substring(0, 26)}
              {experienceData?.title.substring(0, 26).length >= 26 ? "..." : ""}
            </Text>
          </View>
        </View>
        {fromHomeFeed && (
          <TouchableOpacity
            onPress={() => {
              handleLikePress(
                "experienceLike",
                experienceData?.media.images[0].url,
                experienceData?._id
              );
            }}
            style={styles.LikeIconCircle}
          >
            <FeedIcons.LikeIcon />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  ExperienceCard: {
    width: "100%",
    height: 290,
    borderRadius: 8,
    overflow: "hidden",
    marginBottom: 20,
  },
  ExperienceCardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  HomeDisplayCardInfo: {
    position: "absolute",
    width: "100%",
    bottom: 0,
    padding: 16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  transparentPill: {
    borderRadius: 50,
    paddingVertical: 2,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  LikeIconCircle: {
    backgroundColor: "white",
    borderRadius: 50,
    padding: 16,
    zIndex: 1,
    // shadow
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.4,
    shadowRadius: 10,
    elevation: 1,
  },
});
